import { Injectable } from '@angular/core';
import { from, map, Observable } from 'rxjs';

import { BlazeSchema, getColumnKey } from '@blaze-shared/schema-domain';

import { GLOBAL_STYLE_TOKENS } from '../tokens/global-style-tokens';
import { Token } from '../tokens/token';
import { VariableToken } from '../tokens/variable-token';

import { CompiledCustomTemplate } from './compiled-custom-template';
import { SANITIZATION_CONFIG } from './sanitization-config';

@Injectable({ providedIn: 'root' })
export class CustomTemplateRendererService {
  compile(code: string): Observable<CompiledCustomTemplate | null> {
    return this.getHandlebars().pipe(map((handlebars) => handlebars.compile(code)));
  }

  sanitize(html: string): Observable<string> {
    return this.getDomPurify().pipe(
      map((domPurify) => domPurify.sanitize(html, SANITIZATION_CONFIG)),
    );
  }

  createTokens(schema: BlazeSchema | undefined): Token[] {
    if (!schema) {
      return [];
    }

    const schemaVariables = schema.columns
      .filter((column) => !column.isInternal)
      .map(
        (column) =>
          ({
            type: 'variable',
            value: getColumnKey(column) ?? '',
            label: column.name,
            dataType: column.dataType,
          }) satisfies VariableToken,
      );

    return [...schemaVariables, ...GLOBAL_STYLE_TOKENS];
  }

  private getHandlebars(): Observable<any> {
    return from(import('handlebars')).pipe(map((module) => module.default ?? module));
  }

  private getDomPurify(): Observable<any> {
    return from(import('dompurify')).pipe(map((module) => module.default ?? module));
  }
}
